// extracted by mini-css-extract-plugin
export default {"input":"CreationDialog__input___I941o"};